import { render, staticRenderFns } from "./statusbar.vue?vue&type=template&id=687a6bac&scoped=true&"
import script from "./statusbar.vue?vue&type=script&lang=js&"
export * from "./statusbar.vue?vue&type=script&lang=js&"
import style0 from "./statusbar.vue?vue&type=style&index=0&id=687a6bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a6bac",
  null
  
)

export default component.exports